export const SWITCH_STATE = {
  ON: 'ON',
  OFF: 'OFF',
};
